module.exports = __webpack_public_path__ + "assets/img/sm1.ae5522f9.png";